import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getUserProfile = createAsyncThunk(
  'user/getUserProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`users/me/profile`);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  'user/updateUserProfile',
  async ({ gamertag, characterJSON }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `users/me/profile`,
        {
          gamertag,
          characterJSON,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
